export enum TOGGLE_SWITCH_SIZES {
    Small = "small",
    Medium = "medium",
    Large = "large"
}
export enum TOGGLE_SWITCH_LABEL_PLACEMENT {
    End = "end",
    Start = "start"
}
